import React, { ComponentProps, ReactNode } from 'react';

import { Screen } from '@zapier/theme';
import { useMediaProps } from '@zapier/responsive-utils';
import { Margin, Text } from '@zapier/design-system';

import Link from 'app/common/components/Link';

import CTA from './CTA';
import Ordinal from './Ordinal';

type Props = {
  action: ReactNode;
  description: string;
  icon: ComponentProps<typeof CTA.Title>['icon'];
  isActive: boolean;
  learnMoreUrl: string;
  ordinal: number;
  title: string;
};

function Simple({
  action,
  description,
  icon,
  isActive,
  learnMoreUrl,
  ordinal,
  title,
}: Props) {
  const { size = 'small' } = useMediaProps({
    [Screen.queries.tabletPortraitPlus]: { size: 'large' },
  });

  return (
    <CTA>
      <Ordinal isActive={isActive} number={ordinal} />
      <CTA.Info icon={icon} title={title}>
        <Margin margin="10px 0px 0px 0px">
          <Text>{description}</Text> <Link href={learnMoreUrl}>Learn more</Link>
          .
        </Margin>
      </CTA.Info>
      <CTA.Action ariaLabel="edit authentication" size={size}>
        {action}
      </CTA.Action>
    </CTA>
  );
}

export default Simple;
